export default "__VITE_ASSET__D2ka9JfN__";